import React from 'react'
import styles from './FirstView.module.css'
import { FirstViewProps } from './types'

const IMAGES = {
    firstViewImg: '/renewal_lp/firstView/promotionActress.png',
    annotationImg: '/renewal_lp/firstView/annotation.png'
}

const FirstView = ({ dataViewLabel }: FirstViewProps) => {
    return (
        <section data-view-label={dataViewLabel}>
            <div className={styles.contentWrap}>
                <div className={styles.rightContent}>
                    <img src={IMAGES.firstViewImg} alt={'葵わかなさん'}/>
                </div>
                <div className={styles.leftContent}>
                    <h1><span>飲食業界</span>で働く方が<br/>支持する転職サービス</h1>
                    <h2>No.<span className={styles.fontAdjust}>1<span className={styles.notes}>※</span></span></h2>
                    <div className={styles.achievements}>
                        <div className={styles.achievementCircle}>
                            <div className={styles.achievementLabel}>
                                <p>飲食求人</p>
                            </div>
                            <div className={styles.achievementNumber}>
                                <p><span>30,000</span>件<br/>以上</p>
                            </div>
                        </div>
                        <div className={styles.achievementCircle}>
                            <div className={styles.achievementLabel}>
                                <p>転職実績</p>
                            </div>
                            <div className={styles.achievementNumber}>
                                <p><span>5,700</span>人<br/></p>
                                <p>以上</p>
                            </div>
                        </div>
                    </div>
                    <img src={IMAGES.annotationImg} alt={'注釈'} className={styles.annotation}/>
                </div>
            </div>
            <aside className={styles.bannerMessage}>
                <p>好条件の非公開求人も多数保有！</p>
            </aside>
            <div className={styles.favorableConditions}>
                <div className={styles.favorableConditionItem}>
                    <p className={styles.conditionDetail}>月給<span>35</span>万</p>
                    <div className={styles.subConditionDetail}>
                        <p>賞与年2回</p>
                        <p>昇給あり</p>
                    </div>
                </div>
                <span className={styles.verticalSeparator}></span>
                <div className={styles.favorableConditionItem}>
                    <p className={styles.conditionDetail}>週休<span>2</span>日制</p>
                    <div className={styles.subConditionDetail}>
                        <p>GW/夏季/</p>
                        <p>年末年始休暇</p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FirstView
